import { Option } from './option';
import { NOT_SELECTABLE_KEY } from '../components/option-toggle/option-toggle.component';

export enum Department {
    BusinessAnalytics = 'BUSINESS_ANALYTICS',
    Commercial = 'COMMERCIAL',
    Finance = 'FINANCE',
    FoodAndBeverage = 'FOOD_AND_BEVERAGE',
    GeneralManager = 'GENERAL_MANAGER',
    HR = 'HR',
    IT = 'IT',
    MeetingAndEvents = 'MEETINGS_AND_EVENTS',
    Operations = 'OPERATIONS',
    OwnerOrAssetManager = 'OWNER_ASSET_MANAGER',
    RevenueManagement = 'REVENUE_MANAGEMENT',
    Other = 'OTHER',
}

export const DEPARTMENT_LABELS: Record<Department, string> = {
    [Department.BusinessAnalytics]: 'Business Analytics',
    [Department.Commercial]: 'Commercial',
    [Department.Finance]: 'Finance',
    [Department.FoodAndBeverage]: 'Food & Beverage',
    [Department.GeneralManager]: 'General Manager',
    [Department.HR]: 'HR',
    [Department.IT]: 'IT',
    [Department.MeetingAndEvents]: 'Meetings & Events',
    [Department.Operations]: 'Operations',
    [Department.OwnerOrAssetManager]: 'Owner / Asset Manager',
    [Department.RevenueManagement]: 'Revenue Management',
    [Department.Other]: 'Other',
};

export const DEPARTMENT_OPTIONS: Option[] = [
    new Option(NOT_SELECTABLE_KEY, 'Select your department'),
    new Option(Department.BusinessAnalytics, 'Business Analytics'),
    new Option(Department.Commercial, 'Commercial'),
    new Option(Department.Finance, 'Finance'),
    new Option(Department.FoodAndBeverage, 'Food & Beverage'),
    new Option(Department.GeneralManager, 'General Manager'),
    new Option(Department.HR, 'HR'),
    new Option(Department.IT, 'IT'),
    new Option(Department.MeetingAndEvents, 'Meetings & Events'),
    new Option(Department.Operations, 'Operations'),
    new Option(Department.OwnerOrAssetManager, 'Owner / Asset Manager'),
    new Option(Department.RevenueManagement, 'Revenue Management'),
    new Option(Department.Other, 'Other'),
];
